import { isSetter } from '../utils/guards.js';
const withSerialization = ({ atom, serialize: customSerialize, deserialize: customDeserialize, }) => {
    const serialize = (value) => (value === undefined ? undefined : customSerialize(value));
    const deserialize = (value) => (value === undefined ? undefined : customDeserialize(value));
    const get = async () => {
        const serialized = await atom.get();
        return deserialize(serialized);
    };
    const set = async (value) => {
        if (isSetter(value)) {
            return atom.set(async (previousValue) => serialize(await value(deserialize(previousValue))));
        }
        const serialized = serialize(value);
        return atom.set(serialized);
    };
    const observe = (callback) => {
        return atom.observe((value) => callback(deserialize(value), value));
    };
    return { ...atom, get, set, observe };
};
export default withSerialization;
